import {
    BUSINESS_EVENTBRITE_CATEGORY,
    DATING_EVENTBRITE_SUB_CATEGORY,
    EVENTBRITE_CATEGORY_IMAGES_SMALL,
    EVENTBRITE_CATEGORY_MAPPING,
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    FALL_EVENTBRITE_SUB_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    FORMATTED_SUBCATEGORY_MAP,
    HALLOWEEN_EVENTBRITE_SUB_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    HOME_LIFESTYLE_EVENTBRITE_CATEGORY,
    MUSIC_EVENTBRITE_CATEGORY,
    NIGHTLIFE_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    SEASONAL_EVENTBRITE_CATEGORY,
} from '@eventbrite/categories';
import { GenericLazyString } from '@eventbrite/i18n';

type WaysToTourCategory =
    | {
          type: 'category';
          parentCategoryId?: undefined;
          categoryId: keyof typeof EVENTBRITE_CATEGORY_IMAGES_SMALL;
      }
    | {
          type: 'subcategory';
          parentCategoryId: string;
          categoryId: keyof typeof FORMATTED_SUBCATEGORY_MAP;
      };

type FormattedWaysToTourCategory = {
    imageUrl: string;
    label: string | GenericLazyString;
    key: string;
} & WaysToTourCategory;

const WAYS_TO_TOUR_CATEGORIES: WaysToTourCategory[] = [
    {
        type: 'category',
        categoryId: NIGHTLIFE_EVENTBRITE_CATEGORY,
    },
    {
        type: 'subcategory',
        parentCategoryId: HOME_LIFESTYLE_EVENTBRITE_CATEGORY,
        categoryId: DATING_EVENTBRITE_SUB_CATEGORY,
    },
    {
        type: 'category',
        categoryId: MUSIC_EVENTBRITE_CATEGORY,
    },
    {
        type: 'subcategory',
        parentCategoryId: SEASONAL_EVENTBRITE_CATEGORY,
        categoryId: HALLOWEEN_EVENTBRITE_SUB_CATEGORY,
    },
    {
        type: 'category',
        categoryId: BUSINESS_EVENTBRITE_CATEGORY,
    },
    {
        type: 'category',
        categoryId: FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    },
    {
        type: 'subcategory',
        parentCategoryId: SEASONAL_EVENTBRITE_CATEGORY,
        categoryId: FALL_EVENTBRITE_SUB_CATEGORY,
    },
    {
        type: 'category',
        categoryId: PERFORMING_EVENTBRITE_CATEGORY,
    },
    {
        type: 'category',
        categoryId: HOBBIES_EVENTBRITE_CATEGORY,
    },
    {
        type: 'category',
        categoryId: SEASONAL_EVENTBRITE_CATEGORY,
    },
];

export const categories: FormattedWaysToTourCategory[] =
    WAYS_TO_TOUR_CATEGORIES.map((waysToTour) => {
        if (waysToTour.type === 'category') {
            return {
                ...waysToTour,
                imageUrl:
                    EVENTBRITE_CATEGORY_IMAGES_SMALL[waysToTour.categoryId],
                label: EVENTBRITE_CATEGORY_MAPPING[waysToTour.categoryId],
                key: EVENTBRITE_CATEGORY_TO_REFINEMENT[waysToTour.categoryId],
            };
        }

        return {
            ...waysToTour,
            imageUrl:
                FORMATTED_SUBCATEGORY_MAP[waysToTour.categoryId].imageUrlSmall,
            label: FORMATTED_SUBCATEGORY_MAP[waysToTour.categoryId].title,
            key: `${
                EVENTBRITE_CATEGORY_TO_REFINEMENT[waysToTour.parentCategoryId]
            }/${FORMATTED_SUBCATEGORY_MAP[waysToTour.categoryId].refinement}`,
        };
    });
